/**
 * @file FooterPostMenusSlot.tsx
 *
 * @fileoverview Slot inserted in the footer after footer menus (outside menu's grid).
 */

export default function FooterPostMenusSlot() {
  return <></>;
}

export { FooterPostMenusSlot };
